/**
 * The job's quote check — `docs/visit-page.md` §26.4, §26.5 (Board 17 C, E;
 * the rail's line, H).
 *
 * PR 1 defined the answer already — `VisitCheckQuote` and `VisitCheckMissing`
 * in `shared/src/quote-visits.ts`, read by `checkJobVisits()` — so this file
 * names those, and adds only the write body PR 1 keeps local to its route. The
 * rail's slimmer line is `RailQuoteCheck` in `read.ts`.
 */
import { z } from 'zod';
/**
 * `POST /api/v1/jobs/:id/visit-check/create {approvalId, missing}` — **Create
 * the missing visit** (§26.5): `writeQuoteVisits` with `only` and `madeBy:
 * 'visit_check'`, from the approval's snapshot. The same rules as PR 1's
 * route-local `createBody`, which should read this instead.
 */
export const visitCheckCreateSchema = z.object({
    approvalId: z.string().uuid(),
    missing: z.array(z.object({
        quoteVisitId: z.string().uuid().nullish(),
        quoteLineId: z.string().uuid().nullish(),
        seriesIndex: z.number().int().min(1).max(32767),
    }).refine((one) => Boolean(one.quoteVisitId) !== Boolean(one.quoteLineId), { message: 'Name the quote visit or the quote line.' })).min(1).max(500),
});
//# sourceMappingURL=job-visit-check.js.map